import React, { useState } from "react";
import API from "../../ApiService/ApiService";
import Context from "./index";
import Widget from "../../Helpers/Widget";
import { Form } from "antd";

const TopicMasterProvider = (props) => {
  const api = new API();
  const [fetchTopicMasterList, setFetchTopicMasterContextList] = useState([]);
  const [tableFilter, setTableFilter] = useState({
    name: "",
    category_id: "",
    subcategory_id: "",
    subject_id: "",
    page: 1,
    limit: 20,
  });
  const [loader, setLoader] = useState(false);
  const [editForm] = Form.useForm();
  const [editFormData, setEditFormData] = useState({});
  const [editTopicPopup, setEditTopicPopup] = useState(false);
  const [loaderTopic, setLoaderTopic] = useState(false);
  const [topicDeleteLoader, setTopicDeleteLoader] = useState(false);


  const deleteTopic = async (id,fetchTopicMasterContext) => {
    setTopicDeleteLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.remove("topicmaster/delete",id, (err, res) => {
        
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          fetchTopicMasterContext && fetchTopicMasterContext();
          return;
        } else {
          // Widget.showMessage("error", err?.response?.data?.message);
        }
        setTopicDeleteLoader(false);
      }));
  }
  const fetchTopicMasterContext = async (cid, scid, sid) => {
    setLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll(
        "topicmaster",
        {
          ...tableFilter,
          category_id: cid,
          subcategory_id: scid,
          subject_id: sid,
        },
        (err, res) => {
          setLoader(false);
          if (res?.data?.status === 200) {
            setFetchTopicMasterContextList(res?.data?.data);
          } else {
            setFetchTopicMasterContextList([]);
          }
        }
      ));
  };

  const addTopic = async (data, cid, scid, sid, onClose, reset) => {
    const values = {
      name: data.name,
      category_id: cid,
      subcategory_id: scid,
      subject_id: sid,
    };
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("topicmaster/", values, (err, res) => {
        if (res?.data?.status === 200) {
          fetchTopicMasterContext(cid, scid, sid);
          Widget.showMessage("success", res?.data?.message);
          onClose();
          reset();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
      }));
  };
  const editTopic = async (data, id, onClose, reset, cid, scid, sid) => {
    const values = {
      name: data.name,
    };
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("topicmaster/edit",id, values, (err, res) => {
        if (res?.data?.status === 200) {
          fetchTopicMasterContext(cid, scid, sid);
          Widget.showMessage("success", res?.data?.message);
          onClose();
          reset();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
      }));
  };
  return (
    <Context.Provider
      value={{
        ...props,
        fetchTopicMasterList,
        fetchTopicMasterContext,
        addTopic,
        loader,
        tableFilter,
        setTableFilter,
        editTopic,
        editForm,
        editFormData,
        setEditFormData,
        editTopicPopup,
        setEditTopicPopup,
        loaderTopic,
        setLoaderTopic,
        topicDeleteLoader, setTopicDeleteLoader,
        deleteTopic,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default TopicMasterProvider;
